import { useMutation, useQuery } from "@tanstack/react-query";
import { ClaimDto, SearchClaimDto } from "../../../services/dto";
import { IActionResponse, IActionResult } from "../../../assets/utils/lib";
import { ClaimClient } from "../../../services/proxies";
import { Constants } from "../../../assets/utils/lib/constants";

export namespace ClaimService {
  const claimClient = new ClaimClient();

  export const save = () =>
    useMutation<IActionResult<ClaimDto>, Error, ClaimDto>({
      mutationFn: async (payload: ClaimDto) => {
        return await claimClient.saveClaimAsync(payload);
      },
    });

  export const getClaimQuery = (claimId: string | undefined) =>
    useQuery({
      queryKey: ["claimQuery", claimId],
      queryFn: async () => await claimClient.getClaimAsync(claimId),
      enabled: Boolean(claimId && claimId !== Constants.emptyGuid),
    });

  export const getClaimsQuery = (typeId: string | undefined) =>
    useQuery({
      queryKey: ["claimsQuery", typeId],
      queryFn: async () => await claimClient.getClaimsAsync(typeId),
      enabled: Boolean(typeId),
    });

  export const gridQuery = (searchQuery: SearchClaimDto) =>
    useQuery({
      queryKey: ["claimGridQuery", searchQuery],
      queryFn: async () => await claimClient.searchClaimsAsync(searchQuery),
    });

  export const getClaimTypesQuery = () =>
    useQuery({
      queryKey: ["claimTypeQuery"],
      queryFn: async () => await claimClient.getClaimTypesAsync(),
    });

  export const deleteClaim = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) =>
        await claimClient.deleteClaimAsync(id),
    });
}
